import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class MitigationTile implements ViewModel {
  friendlyTypeNameSingular = 'Mitigation Tile';
  apiRoute = CONFIG.apiRoutes.recommendations;

  public runnableModelOrgTreeNodeId: string;
  public orgTreeNodeId: string;
  public name: string;
  public modelName: string;
  public siteName: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.runnableModelOrgTreeNodeId = data.runnableModelOrgTreeNodeId;
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.name = data.name;
    this.modelName = data.modelName;
    this.siteName = data.siteName;
  }
}
